import front from '@/../static/js/proto/CtpFront';
import * as SubUtils from '../SubUtils';
/**
 * 下拉框参数的 store。
 * 没有值时，自动从服务器获取
 */
const Params = {
  namespaced: true,
  state: {
    conditionNotTriggerList: [],
    capital: {},
  },
  getters: {
    /**
     * 未触发条件单列表
     * @param state
     */
    conditionNotTriggerList(state) {
      SubUtils.sub('conditionNotTriggerList', state.conditionNotTriggerList);
      return state.conditionNotTriggerList;
    },
    /**
     * 资金信息
     */
    capital(state) {
      SubUtils.sub('capital', state.capital);
      return state.capital;
    },
  },
  mutations: {
    clearAll(state) {
      state.conditionNotTriggerList = [];
    },
  },
};

export default Params;



// WEBPACK FOOTER //
// ./src/store/modules/Params.ts